"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("./utils");
var _PaginationItem = require("./PaginationItem");
var _PaginationList = require("./PaginationList");
var Pagination = function Pagination(props) {
  var pagesCount = props.pagesCount,
    currentPage = props.currentPage,
    length = props.length,
    linkBase = props.linkBase,
    className = props.className;
  if (pagesCount < 2) return null;

  /* Count of elements to the left and to the right of current element */
  var borderSize = Math.trunc(length / 2);

  /* Offset left position to bring page numbers range up to full length */
  var leftOffset = Math.max(borderSize - (pagesCount - currentPage), 0);

  /* Leftmost and rightmost element of page numbers range */
  var left = Math.max(currentPage - borderSize - leftOffset, 1);
  var right = Math.min(left + length - 1, pagesCount);
  var showToBegin = left > 1;
  var showToNext = right < pagesCount;
  return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
    className: className
  }, showToBegin && /*#__PURE__*/_react["default"].createElement(_PaginationItem.TextLink, {
    href: linkBase
  }, "\u0412 \u043D\u0430\u0447\u0430\u043B\u043E"), /*#__PURE__*/_react["default"].createElement(_PaginationList.PaginationList, {
    left: left,
    length: length,
    currentPage: currentPage,
    linkBase: linkBase
  }), showToNext && /*#__PURE__*/_react["default"].createElement(_PaginationItem.TextLink, {
    href: (0, _utils.buildLink)(linkBase, currentPage + 1)
  }, "\u0414\u0430\u043B\u044C\u0448\u0435"));
};
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "Pagination__StyledContainer",
  componentId: "sc-1ihygyw-0"
})(["display:flex;flex-direction:row;justify-content:center;align-items:center;"]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(Pagination);